import { usePageBySlug } from "@/hooks/usePagesDB";
import StaticPageRenderer from "@/components/feature/StaticPageRenderer";
import NotFound from "../NotFound";

export default function AboutPage() {
  const { page } = usePageBySlug("ueber-uns");
  if (!page) return null;
  if (!page.isPublished) return <NotFound />;

  return <StaticPageRenderer page={page} />;
}